import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import GetIcon from "@/components/font-awesome-icon";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";

const ColorPicker = ({
  title,
  name,
  value,
  onChange,
  options,
  helperTextStyles = {},
  error = "",
  disabled = false,
  ...rest
}) => {
  return (
    <FormControl
      fullWidth
      error={!!error}
      size={"small"}
      sx={{ bgcolor: "var(--palette-grid_table)", minHeight: "40px" }}
    >
      <InputLabel
        id={`color-select`}
        sx={{ color: "var(--palette-grey_text)" }}
      >
        {title}
      </InputLabel>
      <Select
        name={name}
        value={value || ""}
        onChange={(e) => {
          onChange(e);
        }}
        sx={{
          "& .MuiSelect-select": {
            // color: "var(--base-140)", // Set the desired color for the underline here
            color: disabled
              ? "var(--palette-disabled_button_text)"
              : "var(--palette-text)", // Set the desired color for the underline here
            WebkitTextFillColor: disabled
              ? "var(--palette-disabled_button_text)"
              : "var(--palette-text)",
          },
        }}
        MenuProps={{
          PaperProps: {
            className: "custom-scroll",
            style: {
              maxHeight: "250px",
            },
            sx: {
              "& .MuiMenuItem-root.Mui-selected": {
                backgroundColor: "transparent !important",
                color: "var(--palette-secondary_button_text) !important",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "var(--palette-secondary_button_hover)",
              },
              "& .MuiMenuItem-root.Mui-selected:hover": {
                backgroundColor:
                  "var(--palette-secondary_button_hover) !important",
              },
            },
          },
        }}
        label={title}
        size={"small"}
        renderValue={(selected) => {
          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  marginRight: "8px",
                  backgroundColor: options.find((color) => color.id == selected)
                    ?.code,
                }}
              />
              {options.find((color) => color.id == selected)?.name}
            </div>
          );
        }}
        IconComponent={() => (
          <GetIcon
            icon={faChevronDown}
            iconStyles={{
              marginRight: "0.5rem",
              fontSize: "0.625rem",
              color: "var(--palette-text)",
            }}
          />
        )}
        {...rest}
      >
        {options &&
          options.map((colorOption) => (
            <MenuItem key={colorOption.id} value={colorOption.id}>
              <Box display="flex" alignItems="center">
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    backgroundColor: colorOption?.code,
                    marginRight: "8px",
                  }}
                />
                <Typography>{colorOption.name}</Typography>
              </Box>
            </MenuItem>
          ))}
      </Select>
      {error && (
        <FormHelperText
          sx={{
            bgcolor: "var(--palette-grid_table)",
            px: 0.5,
            ...helperTextStyles,
          }}
        >
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default ColorPicker;
